(function () {
  document.documentElement.classList.add('has-js');

  const revealItems = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealItems.forEach((item) => revealObserver.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const nav = document.getElementById(button.getAttribute('aria-controls'));
      const isOpen = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!isOpen));
      button.setAttribute('aria-label', isOpen ? 'فتح القائمة' : 'إغلاق القائمة');
      nav?.classList.toggle('is-open', !isOpen);
    });
  });

  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main]');
    const badge = gallery.querySelector('[data-gallery-badge]');
    const fitMainImage = () => {
      if (!main || !main.naturalWidth || !main.naturalHeight) return;
      main.classList.toggle('is-tall', main.naturalHeight / main.naturalWidth > 1.15);
    };
    if (main) {
      main.addEventListener('load', fitMainImage);
      fitMainImage();
    }
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
      button.addEventListener('click', () => {
        const image = button.querySelector('img');
        if (!main || !image) return;
        const nextSource = button.dataset.large || image.currentSrc || image.src;
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = nextSource;
        main.alt = image.alt;
        main.classList.toggle('is-tall', button.dataset.portrait === 'true');
        if (badge) badge.hidden = button.dataset.noBadge === 'true';
        gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.setAttribute('aria-current', 'false'));
        button.setAttribute('aria-current', 'true');
      });
    });
  });

  document.querySelectorAll('[data-size-guide-open]').forEach((button) => {
    button.addEventListener('click', () => document.getElementById(button.dataset.sizeGuideOpen)?.showModal());
  });
  document.querySelectorAll('[data-dialog-close]').forEach((button) => {
    button.addEventListener('click', () => button.closest('dialog')?.close());
  });
  document.querySelectorAll('dialog').forEach((dialog) => {
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  });

  document.querySelectorAll('.product-info__form').forEach((form) => {
    const optionControls = Array.from(form.querySelectorAll('[data-option-index]'));
    const variantScript = form.querySelector('[data-variants]');
    const variants = variantScript ? JSON.parse(variantScript.textContent) : [];
    const idInput = form.querySelector('[name="id"]');
    const productInfo = form.closest('.product-info');
    const priceNode = productInfo?.querySelector('[data-variant-price]');
    const compareNode = productInfo?.querySelector('[data-variant-compare]');
    const submit = form.querySelector('[data-product-submit]');
    const submitText = submit?.querySelector('[data-submit-text]');
    const quantityInput = form.querySelector('[name="quantity"]');
    const bundleChoices = Array.from(form.querySelectorAll('[data-bundle-choice]'));
    const colorOptionIndex = Number(form.dataset.colorOptionIndex || -1);
    const hasMultipleColors = form.dataset.hasMultipleColors === 'true';
    const primaryColor = form.querySelector('[data-primary-color]');
    const primaryColorWrap = form.querySelector('[data-single-color-wrap]');
    const bundleColorPicker = form.querySelector('[data-bundle-color-picker]');
    const pieceColorRows = Array.from(form.querySelectorAll('[data-piece-color-row]'));
    const pieceColorControls = Array.from(form.querySelectorAll('[data-piece-color-select]'));
    const colorError = form.querySelector('[data-bundle-color-error]');
    const currencyCode = productInfo?.dataset.currencyCode || window.Shopify?.currency?.active || 'USD';
    const formatMoney = (minorUnits) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'ar', { style: 'currency', currency: currencyCode }).format(minorUnits / 100);
      } catch (error) {
        return (minorUnits / 100).toFixed(2) + ' ' + currencyCode;
      }
    };
    const getCount = () => {
      const selectedChoice = bundleChoices.find((choice) => choice.checked);
      const rawCount = Number(selectedChoice?.dataset.quantity || quantityInput?.value || 1);
      return Math.max(1, Math.min(3, Number.isFinite(rawCount) ? rawCount : 1));
    };
    const getVariant = (colorValue) => {
      if (!variants.length) return null;
      if (!optionControls.length) return variants.find((item) => String(item.id) === String(idInput?.value)) || variants[0];
      const selected = new Array(variants[0].options.length);
      optionControls.forEach((control) => { selected[Number(control.dataset.optionIndex)] = control.value; });
      if (colorOptionIndex >= 0 && colorValue != null) selected[colorOptionIndex] = colorValue;
      if (selected.some((value) => value === undefined)) return null;
      return variants.find((item) => item.options.length === selected.length && item.options.every((value, index) => value === selected[index])) || null;
    };
    const getPieceVariant = (pieceIndex) => {
      const colorValue = hasMultipleColors && getCount() > 1
        ? pieceColorControls[pieceIndex]?.value
        : undefined;
      return getVariant(colorValue);
    };
    const refreshBundles = () => {
      bundleChoices.forEach((choice) => {
        const card = choice.closest('.bundle-option');
        const count = Number(choice.dataset.quantity || 1);
        const percent = Number(choice.dataset.percent || 0);
        const itemVariants = Array.from({ length: count }, (_, index) => {
          const colorValue = hasMultipleColors ? pieceColorControls[index]?.value : undefined;
          return getVariant(colorValue);
        });
        if (itemVariants.some((variant) => !variant)) return;
        const subtotal = itemVariants.reduce((sum, variant) => sum + Number(variant.priceRaw || 0), 0);
        const total = Math.round(subtotal * (1 - percent / 100));
        const totalNode = card?.querySelector('[data-bundle-total]');
        const subtotalNode = card?.querySelector('[data-bundle-subtotal]');
        const savingNode = card?.querySelector('[data-bundle-saving]');
        if (totalNode) totalNode.textContent = formatMoney(total);
        if (subtotalNode) {
          subtotalNode.textContent = formatMoney(subtotal);
          subtotalNode.hidden = percent <= 0;
        }
        if (savingNode) savingNode.hidden = percent <= 0;
      });
    };
    const syncBundleCount = (count) => {
      const normalizedCount = Math.max(1, Math.min(3, Number(count) || 1));
      if (quantityInput) quantityInput.value = String(normalizedCount);
      bundleChoices.forEach((choice) => {
        choice.checked = Number(choice.dataset.quantity) === normalizedCount;
        choice.closest('.bundle-option')?.classList.toggle('is-selected', choice.checked);
      });
      if (primaryColor && normalizedCount > 1) {
        pieceColorControls.forEach((control) => {
          if (control.dataset.touched !== 'true') control.value = primaryColor.value;
        });
      }
      if (primaryColorWrap) primaryColorWrap.hidden = hasMultipleColors && normalizedCount > 1;
      if (bundleColorPicker) bundleColorPicker.hidden = !hasMultipleColors || normalizedCount <= 1;
      pieceColorRows.forEach((row) => { row.hidden = Number(row.dataset.pieceNumber) > normalizedCount; });
      refreshBundles();
    };
    bundleChoices.forEach((choice) => choice.addEventListener('change', () => syncBundleCount(choice.dataset.quantity)));
    quantityInput?.addEventListener('input', () => {
      syncBundleCount(quantityInput.value);
      syncVariant();
    });
    const unavailableText = submit?.dataset.unavailableText || 'غير متوفر حالياً';
    const availableText = submit?.dataset.availableText || 'أضيفي إلى السلة';
    const syncVariant = () => {
      if (!variants.length) return;
      const count = getCount();
      const activeVariants = Array.from({ length: count }, (_, index) => getPieceVariant(index));
      const variant = activeVariants[0];
      if (!variant) {
        if (submit) submit.disabled = true;
        if (submitText) submitText.textContent = unavailableText;
        if (colorError) colorError.hidden = false;
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceNode) priceNode.textContent = variant.price;
      if (compareNode) {
        compareNode.textContent = variant.compare || '';
        compareNode.hidden = !variant.compare;
      }
      const allAvailable = activeVariants.every((item) => item?.available);
      if (submit) {
        submit.disabled = !allAvailable;
        if (submitText) submitText.textContent = allAvailable ? availableText : unavailableText;
      }
      if (colorError) colorError.hidden = activeVariants.every(Boolean);
      refreshBundles();
      const variantUrl = new URL(window.location.href);
      variantUrl.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', variantUrl.toString());
    };
    optionControls.forEach((control) => {
      if (control !== primaryColor) control.addEventListener('change', syncVariant);
    });
    primaryColor?.addEventListener('change', () => {
      pieceColorControls.forEach((control) => {
        if (control.dataset.touched !== 'true') control.value = primaryColor.value;
      });
      syncVariant();
    });
    pieceColorControls.forEach((control) => control.addEventListener('change', () => {
      control.dataset.touched = 'true';
      syncVariant();
    }));
    quantityInput?.addEventListener('change', () => syncVariant());
    bundleChoices.forEach((choice) => choice.addEventListener('change', syncVariant));
    form.addEventListener('submit', async (event) => {
      const count = getCount();
      if (!hasMultipleColors || count <= 1) return;
      event.preventDefault();
      const itemVariants = Array.from({ length: count }, (_, index) => getPieceVariant(index));
      if (itemVariants.some((variant) => !variant || !variant.available)) {
        if (colorError) colorError.hidden = false;
        syncVariant();
        return;
      }
      const itemCounts = new Map();
      itemVariants.forEach((variant) => itemCounts.set(variant.id, (itemCounts.get(variant.id) || 0) + 1));
      const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
      if (submit) submit.disabled = true;
      if (submitText) submitText.textContent = 'جارٍ إضافة الباقة…';
      if (colorError) colorError.hidden = true;
      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: Array.from(itemCounts, ([id, quantity]) => ({ id, quantity })) })
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(result.description || result.message || 'تعذّر إضافة الباقة');
        window.location.assign(`${root}cart`);
      } catch (error) {
        if (colorError) colorError.hidden = false;
        syncVariant();
      }
    });
    syncBundleCount(getCount());
    syncVariant();
  });
})();
